<button matRipple
    class="flex items-center justify-center p-2 hover:brightness-95 hover:dark:brightness-105 bg-neutral-300 dark:bg-neutral-950 text-neutral-900 dark:text-neutral-100 border-neutral-100 rounded-md cursor-pointer transition-all duration-300"
    (click)="clicked.emit()">
    <mat-icon [svgIcon]="icon()" class="size-4!" />
</button>